import { useContext } from 'react';

import DisplayContext from './DisplayContext';

const useDisplay = (throwOnMissingContext = true) => {
  const context = useContext(DisplayContext);
  if (context === null) {
    if (throwOnMissingContext) {
      throw new Error('useDisplay must be used within a DisplayProvider');
    }
    return {};
  }
  return context;
};

export default useDisplay;
